import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 13a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M13.45 11.55l2.05 -2.05","key":"svg-1"}],["path",{"d":"M6.4 20a9 9 0 1 1 11.2 0l-11.2 0","key":"svg-2"}]]

const IconDashboard = createReactComponent('outline', 'dashboard', 'Dashboard', __iconNode);

export default IconDashboard;